import { Component } from '@angular/core';

@Component({
	selector: 'app-terms-of-service',
	templateUrl: './terms-of-service.component.html',
	styleUrls: ['./terms-of-service.component.scss'],
	standalone: true
})
export class TermsOfServiceComponent {}
